/**
 * Party Bank Account Event Type
 *
 * What happened to a party bank account, one history row each (ADR D5).
 */
export const PartyBankAccountEventType = {
  /** The row was created, `UNVERIFIED` */
  CREATED: 'CREATED',
  /** A person gave the first signature */
  FIRST_SIGNED: 'FIRST_SIGNED',
  /** The deterministic system check gave the first signature, with its evidence */
  SYSTEM_CHECKED: 'SYSTEM_CHECKED',
  /** A different person gave the second signature */
  VERIFIED: 'VERIFIED',
  /** A signer refused the account */
  REJECTED: 'REJECTED',
  /** One person withdrew the verification */
  REVOKED: 'REVOKED',
  /** The row was deactivated, e.g. replaced by a changed identity; no state change */
  DEACTIVATED: 'DEACTIVATED'
} as const;

export type PartyBankAccountEventType =
  (typeof PartyBankAccountEventType)[keyof typeof PartyBankAccountEventType];
